// Arsenal de Allende - Datos estáticos del equipo
// Nota: Reemplazar con datos reales cuando se conecte al panel Laravel

export const teamInfo = {
  name: "Arsenal de Allende",
  shortName: "Arsenal",
  location: "Allende, Nuevo León, México",
  founded: 2012,
  slogan: "Más que equipo, una familia.",
  modality: "Fútbol 7",
  category: "Primera División Local",
  venue: "Canchas de las Colonias del Norte, Allende, N.L.",
  trophies: 3,
  players: 14,
  logo: "/logo/logo_arsenal_transparente.png",
  teamPhoto: "/imagenes/imagen_equipo_2.png",
};

export const timeline = [
  {
    year: "2012",
    title: "Fundación del Club",
    description: "Nace Arsenal de Allende con la visión de unir a una comunidad a través del fútbol. Un grupo de amigos con una pasión en común.",
  },
  {
    year: "2012",
    title: "Primer Torneo Ganado",
    description: "El primer trofeo en el año de fundación. Un comienzo de leyenda que marcó la identidad ganadora del club.",
  },
  {
    year: "2022",
    title: "10 Años de Gloria",
    description: "Celebración de una década construyendo identidad, hermandad y una cultura ganadora.",
  },
  {
    year: "2025",
    title: "Tercer Campeonato",
    description:
      "El 20 de marzo, Arsenal conquista su tercer título venciendo a Robalo's. Otra noche para la historia arsenalista.",
    galleryLinkLabel: "Ver galería del campeonato",
    galleryImages: [1, 2, 3, 4, 5].map((n) => `/historia/2025/foto${n}.jpg`),
  },
  {
    year: "2026",
    title: "Nueva Era Digital",
    description: "Arsenal lanza su portal oficial para conectar con aficionados y compartir cada momento del equipo.",
  },
];

export const tournaments = [
  { id: 1, name: "Primera División Local · Fútbol 7", season: "Temporada 2026", status: "En curso", position: 2 },
  { id: 2, name: "Liga Municipal Allende", season: "Campeonato 2025", status: "Campeón vs Robalo's", position: 1 },
  { id: 3, name: "Liga Local · Fútbol 7", season: "2012", status: "Primer Campeón", position: 1 },
];

// Partidos los lunes 20:00 (Nuevo León, UTC-6 sin horario de verano).
// Próximo lunes: 11 mayo 2026 · Último jugado: 4 mayo 2026
const MATCH_LOCAL_TZ = "-06:00";

export const schedule = [
  { id: 1, jornada: 1, date: `2026-04-13T20:00:00${MATCH_LOCAL_TZ}`, time: "20:00", home: "Arsenal de Allende", away: "Cuadro Chico", venue: "Canchas Colonias del Norte", status: "played", score: "6-1" },
  { id: 2, jornada: 2, date: `2026-04-20T20:00:00${MATCH_LOCAL_TZ}`, time: "20:00", home: "Arsenal de Allende", away: "—", venue: "Canchas Colonias del Norte", status: "cancelled" },
  { id: 3, jornada: 3, date: `2026-04-27T20:00:00${MATCH_LOCAL_TZ}`, time: "20:00", home: "Arsenal de Allende", away: "Descanchados", venue: "Canchas Colonias del Norte", status: "played", score: "7-4" },
  { id: 4, jornada: 4, date: `2026-05-04T20:00:00${MATCH_LOCAL_TZ}`, time: "20:00", home: "Arsenal de Allende", away: "Servi Bar", venue: "Canchas Colonias del Norte", status: "played", score: "2-3" },
  { id: 5, jornada: 5, date: `2026-05-11T20:00:00${MATCH_LOCAL_TZ}`, time: "20:00", home: "Arsenal de Allende", away: "Galax", venue: "Canchas Colonias del Norte", status: "upcoming" },
];

export const standings = [
  { pos: 1, team: "SERVI BAR", pj: 3, g: 2, e: 1, p: 0, gf: 14, gc: 12, dif: 2, pts: 7, pct: 78, pe: 0 },
  { pos: 2, team: "ARSENAL", pj: 3, g: 2, e: 0, p: 1, gf: 15, gc: 8, dif: 7, pts: 6, pct: 67, pe: 0 },
  { pos: 3, team: "DEPÓSITO ROBALO'S", pj: 2, g: 2, e: 0, p: 0, gf: 5, gc: 2, dif: 3, pts: 6, pct: 100, pe: 0 },
  { pos: 4, team: "GALAX", pj: 2, g: 1, e: 1, p: 0, gf: 9, gc: 6, dif: 3, pts: 4, pct: 67, pe: 0 },
  { pos: 5, team: "CANITO", pj: 1, g: 1, e: 0, p: 0, gf: 12, gc: 4, dif: 8, pts: 3, pct: 100, pe: 0 },
  { pos: 6, team: "TUZOS", pj: 1, g: 1, e: 0, p: 0, gf: 6, gc: 4, dif: 2, pts: 3, pct: 100, pe: 0 },
  { pos: 7, team: "LA POPULAR", pj: 2, g: 0, e: 1, p: 1, gf: 3, gc: 6, dif: -3, pts: 1, pct: 17, pe: 0 },
  { pos: 8, team: "MANCHESTER CITY", pj: 2, g: 0, e: 1, p: 1, gf: 6, gc: 14, dif: -8, pts: 1, pct: 17, pe: 0 },
  { pos: 9, team: "DESCANCHADOS", pj: 2, g: 0, e: 0, p: 2, gf: 9, gc: 13, dif: -4, pts: 0, pct: 0, pe: 0 },
  { pos: 10, team: "SORDEADOS", pj: 2, g: 0, e: 0, p: 2, gf: 5, gc: 9, dif: -4, pts: 0, pct: 0, pe: 0 },
  { pos: 11, team: "CUADRO CHICO", pj: 2, g: 0, e: 0, p: 2, gf: 2, gc: 8, dif: -6, pts: 0, pct: 0, pe: 0 },
];

export const lastMatch = {
  id: 4,
  date: `2026-05-04T20:00:00${MATCH_LOCAL_TZ}`,
  home: { name: "Arsenal de Allende", logo: teamInfo.logo, score: 2 },
  away: { name: "Servi Bar", logo: null, score: 3 },
  venue: "Canchas Colonias del Norte",
  competition: "Liga Municipal · Jornada 4 · Fútbol 7",
  scorers: [
    { player: "Carlos 'Zorro' Mendoza", minute: 14, team: "home" },
    { player: "Luis Ramírez", minute: 28, team: "away" },
    { player: "Javier 'Toro' Ruiz", minute: 52, team: "home" },
    { player: "Luis Ramírez", minute: 68, team: "away" },
    { player: "Daniel Flores", minute: 84, team: "away" },
  ],
};

export const nextMatch = {
  id: 5,
  date: `2026-05-11T20:00:00${MATCH_LOCAL_TZ}`,
  home: { name: "Arsenal de Allende", logo: teamInfo.logo },
  away: { name: "Galax", logo: null },
  venue: "Canchas Colonias del Norte, Allende, N.L.",
  competition: "Liga Municipal · Jornada 5 · Fútbol 7",
};

export const topScorers = [
  { name: "Carlos Mendoza", nickname: "Zorro", goals: 6, matches: 3 },
  { name: "Javier Ruiz", nickname: "Toro", goals: 4, matches: 3 },
  { name: "Roberto Silva", nickname: "Capi", goals: 2, matches: 3 },
  { name: "Miguel Ángel Torres", nickname: "Miki", goals: 2, matches: 3 },
  { name: "Andrés Cortés", nickname: "Chapo", goals: 1, matches: 3 },
];

export const topAssists = [
  { name: "Roberto Silva", nickname: "Capi", assists: 5, matches: 3 },
  { name: "Miguel Ángel Torres", nickname: "Miki", assists: 4, matches: 3 },
  { name: "Javier Ruiz", nickname: "Toro", assists: 2, matches: 3 },
  { name: "Carlos Mendoza", nickname: "Zorro", assists: 2, matches: 3 },
  { name: "Andrés Cortés", nickname: "Chapo", assists: 1, matches: 3 },
];

export const gallery = [
  {
    id: 1,
    type: "image",
    url: "/imagenes/imagen_festejo.png",
    title: "Celebración épica",
    category: "Partido",
    size: "hero", // col-span-8 row-span-2
  },
  {
    id: 2,
    type: "image",
    url: "/imagenes/imagen_sin_gente_noche.png",
    title: "Casa Arsenal",
    category: "Estadio",
    size: "tall", // col-span-4 row-span-2
  },
  {
    id: 3,
    type: "image",
    url: "https://images.unsplash.com/photo-1557161283-c995e88037d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxzb2NjZXIlMjBmYW5zJTIwY2hlZXJpbmclMjBmbGFnfGVufDB8fHx8MTc3ODAzODg4N3ww&ixlib=rb-4.1.0&q=85",
    title: "La afición que nos empuja",
    category: "Afición",
    size: "square",
  },
  {
    id: 4,
    type: "image",
    url: teamInfo.teamPhoto,
    title: "Plantilla oficial 2026",
    category: "Equipo",
    size: "square",
  },
];

const instagramCaptions = [
  "La familia Arsenal lista para la jornada",
  "VICTORIA — ¡Vamos Arsenal!",
  "Así luce nuestra casa",
  "¡La afición es brutal!",
  "Escudo y orgullo arsenalista",
  "Noche de fútbol en Allende",
  "Hermandad en cada entrenamiento",
  "Tercer campeonato en la mira",
  "Fútbol 7 con corazón",
  "Colonias del Norte, nuestro fortín",
  "Todos al estadio",
  "Más que equipo, una familia",
];

export const instagramFeed = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  image: `/imagenes/imagen_${i + 1}.png`,
  likes: 180 + ((i * 47) % 420),
  caption: instagramCaptions[i] ?? `Momento Arsenal #${i + 1}`,
}));
